import script from "./AppAuthFooter.vue?vue&type=script&setup=true&lang=ts"
export * from "./AppAuthFooter.vue?vue&type=script&setup=true&lang=ts"

import "./AppAuthFooter.vue?vue&type=style&index=0&id=674d596c&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-674d596c"]])

export default __exports__